import { useMutation, useQueryClient } from "@tanstack/react-query";
import { viewsClient } from "@views/viewsClient";

const viewsKeys = {
  all: ["views"] as const,
  list: (sessionKey: string, anchor: string | null) =>
    ["views", sessionKey, anchor] as const,
};

export const viewsListQueryOptions = (
  sessionKey: string,
  anchor: string | null,
) => ({
  queryKey: viewsKeys.list(sessionKey, anchor),
  queryFn: () => viewsClient.list(anchor ?? undefined),
});

export const useReviewView = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => viewsClient.review(id),
    meta: { action: "verify that note" },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: viewsKeys.all });
    },
  });
};
